/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, {useState,useContext, useEffect} from "react"
import TextArea from "../../components/TextArea"
import InputBox from "../../components/InputBox"
import { Link } from "react-router-dom"
import { motion } from "framer-motion"
import TopHeader from "../../components/TopHeader"
import { useParams,useLocation } from "react-router-dom"
import Loader from "../../components/Loader"
import { useSelector ,useDispatch} from "react-redux"
import { useNavigate } from "react-router-dom"
import GlobalContext from "../../components/Context/GloablContext"
import { useEditOrganizationMutation,useGetOrganizationQuery,useLazyGetOrganizationQuery } from "../../features/organizationSlice"
import CustomOverLay from "../../components/CustomOverLay"
import SubDivTable from "./Components/SubDivTable"
import AnimatedModel from "../../components/Animation/AnimatedModel"
import EditSubDivModal from "../../components/SubDivOrgModal"
import { handleIsAddModal, resetOrgList } from "./usersSlice"
import { handleIsMonitorAddModal, resetMonitorList } from "./monitorsSlice"
import ConfirmationPrompt from "../../components/ConfirmationPrompt"
import PhoneNumberValidator from "../../components/PhoneNumberInput"
import { phoneCodeArray } from "../../CommonMethods/phoneNumberCountryCodes"
import { handleIsProviderAddModal, resetProviderList } from "./providersSlice"
import { handleEditMessageSent,handleTargetUserEditId } from '../../redux/systemConfigSlice'
import { userService } from "../../services/user.services"
import { broadcastForcedLogout } from "../../CommonMethods/authSession"
import HelpGuideModal from "../../components/HelpGuideModal"
import {useGetHelpGuideAdminQuery} from '../../features/patientSlice'

export default function UpdateOrganization(){
    
    const dispatch=useDispatch()
    const location=useLocation()
    const navigate=useNavigate()
    const country_code=useSelector((state)=>state?.systemConfigData?.globalVariables?.country_code?.split("-")[0])
    const [skip,setSkip]=useState(false)
    const [isPhoneNumberValid,setIsPhoneNumberValid]=useState({'main_number':true})
    const [isAddSubDiv,setIsAddSubDiv] = useState(false)
    const { confirmationStateCancel,setConfirmationStateCancel,confirmationState,setConfirmationState,setToastmessage,toastErrorMessage,setToastErrorMessage,isSideBar,editSocket ,sendMessageToStartEditing,sendMessageToStopEditing } = useContext(GlobalContext)
    const [countryCodeVal,setCountryCodeVal]=useState('')
    const [isDisableCancel,setIsDisableCancel]=useState(true)
    const [submitSelected,setSubmitSeletected]=useState(false)
    const [emptyField,setEmptyField]=useState(false)
    const [index,setIndex]=useState('')
    const [loading,setLoading]=useState(false)
    const [editOrganization]=useEditOrganizationMutation()
    const [confirmation,setConfirmation] = useState(false)
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('')
    const userType=localStorage?.getItem('user_type')!==null?localStorage.getItem('user_type'):sessionStorage.getItem('user_type')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    
    const [updateOrganization, setUpdateOrganization] = useState({
        "org_name": '',
        "main_number": '',
        "address": '',
        "value_added":true,
        "direct_billing":true
    });
    const [hoverProperties,setHoverProperties] = useState({
        'hover':'',
        'hover_index':'',
        'index_to_display_modal':''
    })

    const isFromEdit = location?.state?.[1] || false;
    const originalListingState = Array.isArray(location.state) ? (location.state[0] ?? '') : (location.state ?? '')
    const stateToPass = Array.isArray(location.state) ? '' : location.state;
    const [nextTarget, setNextTarget] = useState('');

    
    const {id} = useParams()
    const {data,isFetching,status}=useGetOrganizationQuery(id,{skip:skip})
    const [trigger,result] = useLazyGetOrganizationQuery()
    const [dataloading,setDataLoading] = useState(true)
    const messageSent=useSelector(state=>state?.systemConfigData?.messageSent)

    const handleInputChange = (id,option)=>{
        setSubmitSeletected(false)
        setEmptyField(false)
        const fieldToUpdate = {
            organization_name:"org_name",
            main_number:"main_number",
            address:"address",
            value_added:"value_added",
            direct_billing:"direct_billing",
        }[id];
        const regex = /^[1-9]\d*$/;
        let sanitizedOption = option;
        let isValid=true
        if (id==="main_number") {
            sanitizedOption = sanitizedOption.replace(/\D/g, "");
            if (!regex.test(option)) {
                isValid=false
            }
        }
        if(!isValid){
            if (fieldToUpdate) {
                setUpdateOrganization((prev) => ({
                    ...prev,
                    [fieldToUpdate]: sanitizedOption
                }));
            }             
            return
        }
        if(fieldToUpdate){
            setIsDisableCancel(false)
            if(fieldToUpdate==="value_added"||fieldToUpdate==="direct_billing"){
                setUpdateOrganization((prev) => ({
                    ...prev,
                    [fieldToUpdate]: !option,
                }));
            }
            else if(fieldToUpdate==="main_number"){
                if(option.length<=20){
                    setUpdateOrganization((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option,
                    }));
                }
            }
            else if(fieldToUpdate==="org_name"){
                if(option.length<=75){
                    setUpdateOrganization((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option,
                    }));
                }

            }
            else{
                setUpdateOrganization((prev) => ({
                    ...prev,
                    [fieldToUpdate]: option,
                }));
            }
            
        }
    }
    const handleSubmit=()=>{
        setSubmitSeletected(true)
        const hasEmptyFields = () => {
            const isOrgNameEmpty = !updateOrganization.org_name.trim();
            const isMainNumberEmpty = !updateOrganization.main_number.trim();
            return isOrgNameEmpty || isMainNumberEmpty;
        };
        if (hasEmptyFields()) {
            setLoading(false);
            setEmptyField(true);
            setToastErrorMessage("Please fill in all the mandatory fields");
            return;
        }
        if ((!(isPhoneNumberValid.main_number)&&updateOrganization?.main_number!=='')) {
            // Delay showing the toast message until isPhoneNumberValid is updated
            setLoading(false);
            return;
        }
        setConfirmationState(true)
    }
    const handleUpdateOrganization = async() => {
        
        try{
            setLoading(true)
            let response=null
            let body = {
                "organization_id": data?.organization_id,
                "organization_name": updateOrganization.org_name.trim(),
                "organization_address": updateOrganization.address.trim(),
                "main_number": updateOrganization.main_number,
                "organization_main_country_code":"+"+(countryCodeVal===""?country_code.split('\t').join(''):countryCodeVal.split('\t').join('')) ,
                "value_added":updateOrganization.value_added,
                "direct_billing":updateOrganization.direct_billing,
            }
            const addRes=await editOrganization({id,body})
            if(addRes?.error?.data?.message){
              
                setLoading(false)
                if(addRes?.error?.data?.message==="Organization name must be unique"){
                    setConfirmationState(false)
                    setToastErrorMessage("Organization already exists. Please try another")
                }else{
                    setConfirmationState(false)
                    setToastErrorMessage(addRes?.error?.data?.message)
                }
                
                
            }
            else{
                setConfirmationState(false)
                navigate(`/manage-organizations/${id}`,{state:originalListingState})
                setToastmessage('Organization updated successfully')
                setIsDisableCancel(true)
                setLoading(false)
            }
        }
        catch(err){
            setLoading(false)
        }
    }

    useEffect(() => {
        if (userType === 'corporate-user') {
            setQueryParamsadmin('type=admin-edit-organization');
        } else {
            setQueryParamsadmin('type=admin-edit-organization');
        }
    }, [userType]);
      
    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);

    const handleCloseBottom = () => {
        if (isDisableCancel && (isFromEdit===true)) {
            navigate(`/manage-organizations/${id}`, {state: originalListingState});
        } else if (isDisableCancel) {
            navigate('/manage-organizations',{state: originalListingState});
        } else {
            setNextTarget(
                (isFromEdit===true)
                    ? 'view'
                    : 'list'
            );
            setConfirmationStateCancel(true);
        }    
        // if (!isDisableCancel) {
        //     setConfirmationStateCancel(true);
        // } else {
        //     navigate('/manage-organizations');
        // }
    };
    const handleOnClickActivate = () => {
        if (confirmationState) {
            handleUpdateOrganization();
        } else {
            setIsDisableCancel(true);
            setConfirmationStateCancel(false);
            if (nextTarget === 'view') {
                navigate(`/manage-organizations/${id}`, {state: originalListingState});
            } else {
                navigate('/manage-organizations', {state: originalListingState});
            }
        }
    };

    function onEditButtonClick(index){
        setIndex(index)
        setHoverProperties((prev)=>({...prev,'index_to_display_modal':index}))
        setConfirmation(true)

    }

    useEffect(()=>{
        let hasLoggedOut = false;
        if (editSocket && !hasLoggedOut) {
            
            editSocket.onmessage = async (event) => {
                if (hasLoggedOut) {
                    return; // Prevent multiple logout calls
                }else if (event.data === "logout") {
                    hasLoggedOut = true;
                    await userService.DuplicateLogout();
                    let arcm_trust_browser_token = localStorage.getItem('arcm_trust_browser_token')
                    let LogoutfromAllTabs = localStorage.getItem('LogoutfromAllTabs')
                    broadcastForcedLogout();
                    localStorage.clear();
                    sessionStorage.clear();
                    localStorage.setItem("arcm_trust_browser_token",arcm_trust_browser_token)
                    localStorage.setItem("LogoutfromAllTabs",LogoutfromAllTabs)
                    sessionStorage.setItem('showDuplicateSessionLogout', 'true');
                    setTimeout(() => {
                        window.location.reload();
                        navigate('/');
                    }, 500);
                }
            };
        }
    },[editSocket])

    useEffect(()=>{
        if(result!==undefined&& result?.data?.organization_id!==undefined){
            dispatch(handleTargetUserEditId(result?.data?.organization_id))
            if(!messageSent&&editSocket){
               
                sendMessageToStartEditing(result?.data?.organization_id)
            
                let message
                editSocket.onmessage = (event) =>{
                    message = event.data
                    if(JSON.parse(message)?.success_status===true && JSON.parse(message)?.message==='Success'){
                        setDataLoading(false)
                    } else{
                        dispatch(handleEditMessageSent(false))
                        navigate('/manage-organizations', {state: originalListingState})
                        { (JSON.parse(message)?.adminId) &&
                            setToastErrorMessage(`A user with username ${decodeURIComponent( JSON.parse(message)?.adminId)} is already editing this organization`)
                        }
                    }
                }    
            }else{
                setDataLoading(false)
            }
            setSkip(true)
            setUpdateOrganization((prev)=>({
                ...prev,
                "org_name": result?.data?.organization_name,
                "main_number": result?.data?.main_number,
                "address": result?.data?.organization_address,
                "value_added":result?.data?.value_added,
                "direct_billing":result?.data?.direct_billing
            }))
            setCountryCodeVal(result?.data?.organization_main_country_code.split('+')[1])
            // setCountryCodeVal(dara?.org_name.countryCodeList.split('+')[2][3])
            // dispatch(addAllInitially([data,true]))
        }
        return(()=>{
          
            if(((location.state===null || location.state==='')&&result?.data?.organization_id!==undefined)){
                
                sendMessageToStopEditing(result?.data?.organization_main_country_code)
            }  
        })
    },[result])

    useEffect(()=>{
        if(id){
            trigger(id)      
        }       
    },[id])

    useEffect(()=>{
        return(()=>{
       
            if(location?.state!==null||location?.state!==''){
         
                sendMessageToStopEditing()
            }
        })
       
    },[])

    return(
        <>
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={"Manage Organizations"}/>
                {((isFetching&&status!=="fulfilled"))?<CustomOverLay Active text="Loading Organization Details..." classKey={`absolute top-0 left-0 z-50 overflowhidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar?'opened-sidebar-config':'system_config_overlay'}`}/>:<>
                    <div className='bg-white rounded-lg pb-3 pt-5 pl-[30px] pr-[10px] h-customh3'>
                        <motion.div 
                            className="mt-1"
                            animate={{ x: 0 }}
                            initial={{ x: -10 }}
                            transition={{duration:0.5}}
                        >
                            <div className='bg-white'>
                                <div className='pr-7'>
                                    <div className='flex items-center mb-5'>
                                        <Link to="/manage-organizations" state={originalListingState}>
                                            <h1 className="text-sm font-normal text-[#52555D]">List of Organizations</h1>
                                        </Link>
                                        {isFromEdit===true &&<>
                                            <span className='mx-2'><img loading='lazy' decoding='async' src="/images/breadcrumb-icon.svg" alt="icon"/></span>

                                            <Link to={`/manage-organizations/${location?.state?.[2]}`} state={originalListingState}>
                                                <h1 className="text-sm font-normal text-[#52555D]">View Organization</h1>
                                            </Link>
                                        </>}
                                        <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                                        <h1 className="text-sm font-normal text-[#008586]">Edit Organization</h1>
                                        {
                                            userType !=='super-admin' &&
                                            <span   onClick={() => setHelpGuideModel(true)} className='ml-auto min-w-fit cursor-pointer'>
                                                <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                                            </span> 
                                        }
                                    </div>
                                    {isFromEdit===true ?
                                        <div onClick={handleCloseBottom} className=' items-center cursor-pointer min-w-max flex'>
                                            <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                                            <span className='text-sm font-normal text-[#008586] pl-3'>Go back to View Organization</span>
                                        </div> 
                                        :    
                                        <div onClick={handleCloseBottom} state={location.state} className='flex  cursor-pointer items-center'>
                                            <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                                            <span className='text-sm font-normal text-[#008586] ml-3'>Go back to Listing</span>
                                        </div>
                                    }
                                   
                                    
                                    <h1 className='text-xl font-normal text-[#000000] w-full text-center mt-[-23px]'>
                                        Edit Organization
                                    </h1>
                                    <p className='text-end pt-2 pb-1'>‘*’ Indicates mandatory field</p>
                                </div>
                                <div className='pr-5 h-customh14 overflow-auto scrollbar_purple bg-white'>
                                    <div className="pt-4">
                                        <div className="xl:w-[90%] w-[95%]">
                                            <div className='flex flex-wrap -mx-[18px]'>
                                                <div className={`w-2/3 px-[18px] mb-6`}>
                                                    <div className='w-full'>
                                                        <InputBox
                                                            label={"Organization Name*"} 
                                                            placeholder={"Enter Organization Name"}
                                                            id={"organization_name"}
                                                            htmlFor={"Admin_Username"}
                                                            value={updateOrganization?.org_name}
                                                            handleOnChangeInput={handleInputChange}
                                                            emptyField={emptyField&&updateOrganization?.org_name.trim()===""}
                                                            usernameError={submitSelected&&toastErrorMessage==="Organization already exists. Please try another"}

                                                        />
                                                    </div>
                                                </div>
                                                <div className='w-1/3 px-[18px] mb-6'>
                                                    <div className='w-full'>
                                                           
                                                        <PhoneNumberValidator
                                                            label={"Main Number*"} 
                                                            placeholder={"Enter main number"}
                                                            id={"main_number"}
                                                            htmlFor={"Admin_Mobile_Number"}
                                                            value={updateOrganization?.main_number}

                                                            handleOnChangeInput={handleInputChange}
                                                            isCode={true}
                                                            emptyField={emptyField&&updateOrganization.main_number.trim()===""}
                                                            countryCodeList={phoneCodeArray}
                                                            country_code={country_code}
                                                            countryCodeVal={countryCodeVal}
                                                            setCountryCodeVal={setCountryCodeVal}
                                                            isPhoneNumberValid={isPhoneNumberValid?.main_number}
                                                            setIsPhoneNumberValid={setIsPhoneNumberValid}
                                                            submitSelected={submitSelected}
                                                            //onPhoneNumberValidationChange={handlePhoneNumberValidationChange}

                                                        />
                                                    </div>
                                                </div>
                                                <div className='w-full px-[18px] mb-6'>
                                                    <TextArea label={'Address'}
                                                        htmlFor={'user_address'}
                                                        id={'address'}
                                                        value={updateOrganization?.address}
                                                        placeholder={'Enter Address'}
                                                        // emptyField={false}
                                                        handleOnChangeInput={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='flex items-center xl:justify-start justify-between flex-wrap mt-[24px] w-full'>
                                            <div className="flex items-center">
                                                <p className='font-normal text-[#000000] xl:pl-1 pr-[30px]'>Value Added</p>
                                                <div className="p-2">
                                                    <div className="relative custom-radioBlue flex items-center">
                                                        <input id="value_added_true" type="radio" name="default-radio1" checked={updateOrganization?.value_added} onChange={()=>handleInputChange("value_added",false)}/>
                                                        <label htmlFor="value_added_true" className={`text-base font-normal ${updateOrganization?.value_added ? 'text-[#000]' : 'text-[#52555D]'} pl-8 w-full cursor-pointer`}>
                                                            True
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="p-2">
                                                    <div className="relative custom-radioBlue flex items-center" >
                                                        <input id="value_added_false"  type="radio" name="default-radio1" checked={!updateOrganization?.value_added} onChange={()=>handleInputChange("value_added",true)}/>
                                                        <label htmlFor="value_added_false" className={`text-base font-normal ${!updateOrganization?.value_added ? 'text-[#000]' : 'text-[#52555D]'} pl-8 w-full cursor-pointer`}>
                                                            False 
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex items-center">
                                                <p className='font-normal text-[#000000] 2xl:ml-20 xl:ml-14 pr-[30px]'>Direct Billing</p>
                                                <div className="p-2">
                                                    <div className="relative custom-radioBlue flex items-center">
                                                        <input id="direct_billing_true" type="radio" name="default-radio2" checked={updateOrganization?.direct_billing} onChange={()=>handleInputChange("direct_billing",false)}/>
                                                        <label htmlFor="direct_billing_true" className={`text-base font-normal ${updateOrganization?.direct_billing ? 'text-[#000]' : 'text-[#52555D]'} pl-8 w-full cursor-pointer`}>
                                                            True
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="p-2">
                                                    <div className="relative custom-radioBlue flex items-center" >
                                                        <input id="direct_billing_false"  type="radio" name="default-radio" checked={!updateOrganization?.direct_billing} onChange={()=>handleInputChange("direct_billing",true)}/>
                                                        <label htmlFor="direct_billing_false" className={`text-base font-normal ${!updateOrganization?.direct_billing ? 'text-[#000]' : 'text-[#52555D]'} pl-8 w-full cursor-pointer`}>
                                                            False 
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex justify-end items-center">
                                            <button onClick={()=>{setConfirmation(true),setIsAddSubDiv(true),dispatch(handleIsAddModal([true])),dispatch(handleIsMonitorAddModal([true])),dispatch(handleIsProviderAddModal([true]))}} type='button' className="px-[15px] py-2.5 rounded-[15px] flex items-center hover:bg-[#E7EAF4] text-base font-normal text-[#000000]">
                                                <img src="/images/add-plus-red.svg" alt="icon" />
                                                <span className='pl-2'>
                                                    Add
                                                </span>
                                            </button>
                                        </div>
                                        <SubDivTable viewOrganizationDetails={data} edit={true} onEditButtonClick={onEditButtonClick} hoverProperties={hoverProperties} setHoverProperties={setHoverProperties} confirmation={confirmation}/>
                                    </div>
                                </div>
                                <div className='flex justify-end pr-5'>
                                    <button type='button'
                                        id="cancel"
                                        onClick={handleCloseBottom}
                                        // disabled={isDisableCancel}
                                        className={` px-4 py-2.5 mr-5 text-lg font-semibold disabled:opacity-50 text-[#972E4C] border border-[#972E4C] rounded-[16px] mt-2.5 xl:w-[148px] w-[130px]
                                            bg-[#fff] hover:bg-[#fff] focus:bg-[#fff]`}>
                                        {"Cancel"}
                                    </button>
                                    <button type='button'
                                        id="update"
                                        onClick={handleSubmit}
                                        // disabled={loading}
                                        className={`px-4 py-2.5 text-lg font-semibold text-[#fff] rounded-[16px] mt-2.5 w-[148px]
                                bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]`}>
                                        Update
                                    </button>
                                </div>
                            </div>
                        </motion.div>
                    </div>

                </>
                }
            </div>
          
            {(confirmationState||confirmationStateCancel) &&
            <AnimatedModel
                Children={
                    <ConfirmationPrompt
                              
                        handleOnCLickActivate={handleOnClickActivate}
                        handleClose={confirmationState?()=>{setConfirmationState(false)}:()=>{setConfirmationStateCancel(false)}}
                        data-testid="confirm-btn"
                        disabled={loading}
                        tittle={confirmationStateCancel?'Cancel':`${'Update Organization'}`}
                        message={confirmationState?`Are you sure you want to update this organization?`:'Are you sure you want to cancel the changes?'}
                        buttonName={true && !loading ? "Yes" : <span>{<Loader />}</span>}
                        CancelButton={'No'}

                    />
                }
            />
            }
            {confirmation && 
            <AnimatedModel key="edit-model"
                Children={
                    <EditSubDivModal
                        handleOnCLickActivate={''}
                        handleClose={() => {setIsAddSubDiv(false),setConfirmation(false),dispatch(handleIsAddModal([''])),dispatch(handleIsMonitorAddModal([''])),dispatch(handleIsProviderAddModal([''])),setHoverProperties((prev)=>({...prev,index_to_display_modal:''})),dispatch(resetOrgList()),dispatch(resetMonitorList()),dispatch(resetProviderList())}}
                        data={isAddSubDiv?undefined:data?.sub_divisions[index]}
                        organization_id={data?.organization_id}
                        add={isAddSubDiv}
                        buttonName = {`Save & Apply`}
                        loadingActivation={false}
                    />
                }
            />  
            }
            {(helpGuideModel && helpguidestatus==="fulfilled") &&
            <HelpGuideModal
                setHelpGuideModel={setHelpGuideModel}
                pdfUrl={helpguidedata} // Pass the PDF URL to the modal
            />
            }
        </>
    )
}